import TicketSoldList from "./TicketSoldList";

export default TicketSoldList